import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { CompanyHeaderComponent } from 'app/securities-level/company-header/company-header.component'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../environments/environment'
import { StoreService } from '../../service/store.service'
import { AuthorizeService } from '../../service/authorize.service'
@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss']
})
export class AdditionalInfoComponent implements OnInit, AfterViewInit {
  symbolSearch
  companyProfile
  securityStatistic
  signPostin
  bodList
  bodSize

  @ViewChild('companyHeaderComponent')
  companyHeaderComponent: CompanyHeaderComponent
  subscription: Subscription
  print = false
  pdf = false
  printPage = false
  getPrint
  symbol
  displayHeader
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print

    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)

    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol)
    }

    this.store.getSecurityProfileNewResultObservable().subscribe(response => {
      if (!response) {
        return
      }
      this.symbol = response['securitySymbol']
    })
    if (this.print || this.pdf) {
      this.displayHeader = true
      this.printPage = true
    } else {
      this.displayHeader = false
      this.printPage = false
    }
  }
  get isUserHasPermission(): Boolean {
    return this.authorization.hasRole('ROLE_USER')
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'email',
      this.exportEmail(this.symbol, this.cpmService)
    )
    arrayOfFunctions.set('print', this.exportPrint(this.symbol))
    arrayOfFunctions.set('pdf', this.exportPdf(this.symbol))
    return arrayOfFunctions
  }

  exportPrint = function (symbol) {
    return function executiveSummaryPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      window.open(
        `/#/additionalInfo/${endcodeSymbol}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdf = function (symbol) {
    const service = this.cpmService
    return function executiveSummaryPdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/additionalInfo?symbol=${endcodeSymbol}`
      )
    }
  }

  exportEmail = function (symbol, service) {
    return function mailsectorPopup() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.saveAdditionalInfo(endcodeSymbol).then(filename => {
        const subject = 'Additional information'
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        )
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`
      })
    }
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 3000);
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/additional-info/additional-info.component.ts